//Logos no seleccionados
import manual from "assets/images/logos/gris-disabled/manual.svg"
import user from "assets/customIcons/nonSelectedUB.svg"
import tribboo from "assets/images/logos/gris-disabled/tribboo.svg"
import cype from "assets/images/logos/gris-disabled/cype.svg"
import itec from "assets/images/logos/gris-disabled/itec.svg"
import preoc from "assets/images/logos/gris-disabled/preoc-premeti.svg"
//Logos seleccionados
import manualEnabled from "assets/images/logos/color-enabled/manual.svg"
import userEnabled from "assets/customIcons/selectedUB.svg"
import tribbooEnabled from "assets/images/logos/color-enabled/tribboo.svg"
import cypeEnabled from "assets/images/logos/color-enabled/cype.svg"
import itecEnabled from "assets/images/logos/color-enabled/itec.svg"
import preocEnabled from "assets/images/logos/color-enabled/preoc-premeti.svg"
import { GRANTED, BANKS_PUBLIC, BANKS_CUSTOM } from "constants/entitlements"

export const banks = [
  {
    type: "Manual part",
    element: "manual",
    logo: manual,
    logoEnabled: manualEnabled,
    entitlement: GRANTED,
    entitlementTitle: "Entrada manual",
  },
  {
    type: "User database",
    element: "user",
    logo: user,
    logoEnabled: userEnabled,
    filter: "brightness(0.7)",
    entitlement: BANKS_CUSTOM,
    entitlementTitle: "Mi Banco de Precios",
  },
  {
    type: "Tribboo database",
    element: "tribbo",
    logo: tribboo,
    logoEnabled: tribbooEnabled,
    entitlement: BANKS_PUBLIC,
    entitlementTitle: "Banco de Precios Tribboo",
  },
  {
    type: "Cype database",
    element: "cype",
    logo: cype,
    logoEnabled: cypeEnabled,
    entitlement: BANKS_PUBLIC,
    entitlementTitle: "Banco de Precios Cype",
  },
  {
    type: "Bedec database",
    element: "bedec",
    logo: itec,
    logoEnabled: itecEnabled,
    entitlement: BANKS_PUBLIC,
    entitlementTitle: "Banco de Precios Itec",
  },
  {
    type: "Preoc database",
    element: "preoc",
    logo: preoc,
    logoEnabled: preocEnabled,
    entitlement: BANKS_PUBLIC,
    entitlementTitle: "Banco de Precios Preoc",
  },
]
